var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b13nz1d6xc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BFFB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2072F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 0h70a6 6 0 0 1 6 6v68a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z",
    id: "u9i7vasfsa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1zf2cnzinb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u9i7vasfsa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    d: "M76 .5c1.519 0 2.894.616 3.89 1.61A5.483 5.483 0 0 1 81.5 6v68a5.483 5.483 0 0 1-1.61 3.89A5.483 5.483 0 0 1 76 79.5H6a5.483 5.483 0 0 1-3.89-1.61A5.483 5.483 0 0 1 .5 74V6c0-1.519.616-2.894 1.61-3.89A5.483 5.483 0 0 1 6 .5z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#1zf2cnzinb)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.916 0H8.079A8.076 8.076 0 0 0 0 8.08v23.845A8.075 8.075 0 0 0 8.079 40h23.842A8.08 8.08 0 0 0 40 31.92V8.08A8.084 8.084 0 0 0 31.916 0z",
    fill: "url(#b13nz1d6xc)",
    transform: "translate(21 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.828 17.19.81-1.4a1.822 1.822 0 1 1 3.159 1.82l-7.804 13.51h5.644c1.83 0 2.855 2.15 2.06 3.64H28.149c-1.01 0-1.82-.81-1.82-1.82s.81-1.82 1.82-1.82h4.64l5.939-10.295-1.855-3.22a1.824 1.824 0 0 1 3.16-1.82l.795 1.405zm-7.02 19.445-1.75 3.035a1.822 1.822 0 1 1-3.159-1.82l1.3-2.25c1.47-.455 2.665-.105 3.61 1.035zm15.069-5.505h4.734c1.01 0 1.82.81 1.82 1.82s-.81 1.82-1.82 1.82h-2.63l1.775 3.08a1.824 1.824 0 0 1-3.16 1.82c-2.99-5.185-5.234-9.065-6.724-11.65-1.525-2.63-.435-5.27.64-6.165 1.195 2.05 2.98 5.145 5.365 9.275z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    mask: "url(#1zf2cnzinb)",
    d: "M0 56h82v24H0z"
  }), /*#__PURE__*/React.createElement("text", {
    mask: "url(#1zf2cnzinb)",
    fontFamily: "Roboto, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 500,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.461,
    y: 73
  }, "App Store")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIos);
export default __webpack_public_path__ + "static/media/play_store_ios.a6adb927c163f6888103e4b2d3c69ed3.svg";
export { ForwardRef as ReactComponent };